import {
  Box,
  Container,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import { useRef } from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import ServicePerformanceAnnualTargets from './components/report-sections/ServicePerformanceAnnualTargets';
import ServicePerformanceReportHeader from './components/report-headers/ServicePerformanceReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';

function ServicePerformance() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Service Performance"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>
                In accordance with section 261B of the Local government Act 2002, the Department of Internal Affairs (DIA) requires local city and district councils to measure and report a set of standard, mandatory Non-Financial Performance Measures (NFPM) as non-financial service levels to their communities.
              </Text>
              <Text mb={4}>
                The Service Performance page shows the annual results that RCAs have published on their websites for the NFPM Roads and Footpaths measures.
              </Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <ServicePerformanceReportHeader />
          <ServicePerformanceAnnualTargets />
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default ServicePerformance;
